export default __webpack_public_path__ + "static/media/w5.1db001f9.png";